export const reviewsMap = {
  spr: 'Shopify Product Reviews',
  judgeme: 'Judge.me',
  loox: 'Loox',
  ryviu: 'Ryviu',
  stamped: 'Stamped',
  alireviews: 'Ali Reviews',
  yotpo: 'Yotpo',
  growave: 'Growave',
  hulkapps: 'Product Reviews with Photos by HulkApps',
  areviewsapp: 'Areviews ‑ Reviews Importer'
}

export const miniReviewSupported = ['spr', 'loox', 'ryviu', 'stamped', 'judgeme', 'growave', 'alireviews']
